import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import RequireAuth from './components/RequireAuth';
import InstagramOAuthCallback from './components/InstagramOAuthCallback';
import Login from './components/Login';
import Dashboard from './components/dashboard/Dashboard';
import ImpedirSalidaAlLogin from './components/ImpedirSalidaAlLogin';
import { RedireccionComentariosInstagram, RedireccionDashboard } from './rutas/RedireccionesConsola';

function App() {
  return (
    <Router>
      <div className="main-bg">
        <ImpedirSalidaAlLogin />
        <Routes>
          <Route path="/" element={<Login />} />
          {/* <Route path="/register" element={<Register />} /> */}
          <Route path="/dashboard" element={<RedireccionDashboard />} />
          <Route path="/dashboard/instagram/:botId/comments" element={<RedireccionComentariosInstagram />} />
          {/*
           * La consola. Las hijas no llevan elemento: el Dashboard lee la ruta
           * con useRutaConsola(). Al ser el mismo elemento en la misma
           * posición, cambiar de sección no lo desmonta, así que ni se recrea
           * el cliente STOMP ni se vuelven a pedir los datos de arranque.
           * La guarda de rol de /admin se pinta en el <Outlet /> del Dashboard.
           */}
          <Route
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          >
            <Route path="/bots" />
            <Route path="/bots/:botId" />
            <Route path="/bots/:botId/:seccion" />
            <Route path="/bots/:botId/:seccion/:detalleId" />
            <Route path="/admin" element={<RequireAuth roles={['ROLE_ADMIN']} />} />
          </Route>
          {/*
           * Rutas de aterrizaje del OAuth de Instagram. NO se envuelven en
           * RequireAuth porque la pestaña popup se abre con un user gesture
           * sin acceso al estado de auth de la pestaña padre y forzar un
           * gating aquí provocaría loops o "Sin acceso" en la propia
           * pantalla de éxito. La protección real ya la hace el backend
           * (state firmado HMAC), no esta página, que sólo cierra el
           * popup y notifica al opener.
           */}
          <Route path="/instagram-conectado" element={<InstagramOAuthCallback kind="success" />} />
          <Route path="/instagram-error" element={<InstagramOAuthCallback kind="error" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
